// extracted by mini-css-extract-plugin
module.exports = {"title":"src-screens-BrandsPage-components-modal-ModalBrand-module__title--2ZX0v","actions_btn":"src-screens-BrandsPage-components-modal-ModalBrand-module__actions_btn--2dc8M"};